import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["published", "form"]

  saveAsDraft(event) {
    if (this.hasPublishedTarget) {
      this.publishedTarget.value = "false"
    }
  }

  publish(event) {
    if (this.hasPublishedTarget) {
      this.publishedTarget.value = "true"
    }
  }
}
